import axios from 'axios';
import { buildPublicPetitionPath, topicsShortcutFunc } from '../Variables';
import {
  BACKEND_VALIDATION_API_URL,
  FIREBASE_STAGING_API_URL,
  HAZTEOIR_LANGUAGE,
  getBackendValidationAdminUrl,
  getCurrentHost,
  isBackendValidationHost,
  isFirebaseStagingHost,
  isHazteoirHost,
  shouldUseCurrentFrontendOrigin,
} from '../utils/hostRouting';
//import { HOST, LOCAL_JSON } from "../Variables";

const host = getCurrentHost();
const environment = ['dev', 'prod', 'alpha'].find((env) => host.includes(env));
// export const API = "./staticData/petitions.json";
export const API = `${window.location.origin}/staticData/petitions.json`;
export const DEV_2_API = 'https://api-dev.citizengo.org/api/v1/petition';
// The function returns a Promis, so the data will be available in .then ()
export function getData() {
  return axios.get(checkUrl());
}
export function getPetitionData() {
  return axios.get(checkUrl());
}

export const checkHost = (direction, region, accounts, nid) => {
  const backendValidationAdminUrl = getBackendValidationAdminUrl({
    candidateHost: host,
    direction,
    region,
    accounts,
    nid,
  });

  if (backendValidationAdminUrl) {
    return backendValidationAdminUrl;
  } else if (['dev', 'prod', 'alpha'].some((env) => host.includes(env))) {
    return `${checkUrl()}/admin/accounts/${direction}/?region=${
      region === 'hazteoir' ? 'es-es' : region
    }&${nid ? `pid=${nid}` : ''}`;
  } else if (host.includes('localhost')) {
    return `http://localhost:9988/admin/${accounts}/${direction}?region=${
      region === 'hazteoir' ? 'es-es' : region
    }&${nid ? `pid=${nid}` : ''}`;
  } else if (isFirebaseStagingHost(host)) {
    return `${FIREBASE_STAGING_API_URL}/admin/accounts/${direction}/?region=${
      region === 'hazteoir' ? 'es-es' : region
    }&${nid ? `pid=${nid}` : ''}`;
  }
   else {
    return `https://admin.citizengo.org/admin/${accounts}/${direction}?region=${
      region === 'hazteoir' ? 'es-es' : region
    }&${nid ? `pid=${nid}` : ''}`;
  }
};

export const checkUrl = () => {
  if (host.includes('localhost')) {
    return 'https://api.citizengo.org';
  } else if (isBackendValidationHost(host)) {
    return BACKEND_VALIDATION_API_URL;
  } else if (environment) {
    return `https://api-${environment}.citizengo.org`;
  } else if (isFirebaseStagingHost(host)) {
    return FIREBASE_STAGING_API_URL;
  }
   else {
    return 'https://api.citizengo.org';
  }
};

export const addImgSourceParam = () => {
  if (['dev', 'prod', 'alpha'].some((env) => host.includes(env))) {
    return '&img_source=new';
  } else {
    return '';
  }
};

export const checkFrontendURL = () => {
  if (host.includes('localhost')) {
    return 'http://localhost:3000';
  } else if (isBackendValidationHost(host)) {
    return window.location.origin;
  } else if (environment) {
    return `https://app-${environment}.citizengo.org`;
  } else if (shouldUseCurrentFrontendOrigin(host)) {
    return window.location.origin;
  } else if (host.includes('frontend-test-environment')) {
    return 'https://frontend-test-environment.web.app';
  } else {
    return 'https://citizengo.org';
  }
};

export const LP_PARAMS_ENV = () => {
  if (host.includes('localhost')) {
    return 'localhost';
  } else if (isBackendValidationHost(host)) {
    return 'staging';
  } else if (environment) {
    return environment;
  } else if (isFirebaseStagingHost(host)) {
    return 'staging';
  } else {
    return 'prod';
  }
};

export const myOptInValues = (segment) => {
  const segmentMap = {
    de: 'de',
    es: 'es',
    en: 'en',
    hazteoir: 'ho',
    pt: 'pt',
  };
  for (let key in segmentMap) {
    if (segment.includes(key)) {
      return segmentMap[key];
    }
  }
  return segment;
};

export const gdprCountries = ['AT','BE','BG','BR','CY','CZ','DE','DK','EE','ES','FI','FR','GB','GR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','NO','LI','IS','AX','AD','BL','GF','PF','MF','MQ','NC','PM','RE','UK','WF','YT'];

// Change the country code if it is different in the backend and frontend.
export const changeListCode = (listCode) => {
  switch(listCode) {
    case "nl-be":
      return "vls";
    case "es-row":
      return "es-lat";
    case "vls-be":
      return "vls";
    default:
      return listCode;
  }
}

// Change the segment code if it is different in the backend and frontend.
// if segment code doesn't exist in i18next, navigate to the 404 page
export const setProperSegmentCode = (resData, url, topicCode, id, urlParams) => {
  const topicPath = topicsShortcutFunc(topicCode);
  const expectedPathSegment = isHazteoirHost(host) && resData === HAZTEOIR_LANGUAGE
    ? topicPath
    : resData;

  if (url.includes('nl-be')) {
    return;
  } else if (expectedPathSegment !== url) {
    window.location.href = `${buildPublicPetitionPath(resData, topicPath, id)}${urlParams}`;
    return;
  } else return;
}

const postWebpageEvent = async (payload, errorMessage) => {
  try {
    await axios.post(`${checkUrl()}/api/v1/webpage-events`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error(errorMessage, error);
  }
};

export const trackClickEvent = async (userEmail, linkID, fullUrl) => {

  if (!userEmail || userEmail === false) return;

  const payload = {
    email: userEmail,
    eventName: "webpageLinkClicked",
    dataFields: {
      linkID: linkID,
      url: fullUrl,
      webpageID: "Petition Page",
      referrer: document.referrer || "",
    },
  };

  await postWebpageEvent(payload, "Error tracking click event:");
}

export const trackPageVisit = async (userEmail, utmCampaign, programName, webpageID, campaignID) => {

  if (!userEmail || userEmail === false) return;

  const payload = {
    email: userEmail,
    eventName: "webpageVisited",
    dataFields: {
      url: window.location.href,
      campaignID: campaignID ? campaignID : "", // get campaignID from url - not utmCampaign!!!
      campaignName: utmCampaign,
      programName: programName,
      webpageID: webpageID,
      referrer: document.referrer || "",
    },
  }

  await postWebpageEvent(payload, "Error tracking page visit:");
}
